/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationStage } from './ApplicationStage'
import {
  ApplicationStageFromJSON,
  ApplicationStageFromJSONTyped,
  ApplicationStageToJSON,
} from './ApplicationStage'

/**
 *
 * @export
 * @interface SaveDataFirstStage200ResponseData
 */
export interface SaveDataFirstStage200ResponseData {
  /**
   * Порядковый номер созданной заявки
   * @type {number}
   * @memberof SaveDataFirstStage200ResponseData
   */
  applicationId: number
  /**
   * Следующая стадия создания
   * @type {ApplicationStage}
   * @memberof SaveDataFirstStage200ResponseData
   */
  nextStage: ApplicationStage
}

/**
 * Check if a given object implements the SaveDataFirstStage200ResponseData interface.
 */
export function instanceOfSaveDataFirstStage200ResponseData(
  value: object
): value is SaveDataFirstStage200ResponseData {
  if (!('applicationId' in value) || value['applicationId'] === undefined)
    return false
  if (!('nextStage' in value) || value['nextStage'] === undefined) return false
  return true
}

export function SaveDataFirstStage200ResponseDataFromJSON(
  json: any
): SaveDataFirstStage200ResponseData {
  return SaveDataFirstStage200ResponseDataFromJSONTyped(json, false)
}

export function SaveDataFirstStage200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SaveDataFirstStage200ResponseData {
  if (json == null) {
    return json
  }
  return {
    applicationId: json['applicationId'],
    nextStage: ApplicationStageFromJSON(json['nextStage']),
  }
}

export function SaveDataFirstStage200ResponseDataToJSON(
  value?: SaveDataFirstStage200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    applicationId: value['applicationId'],
    nextStage: ApplicationStageToJSON(value['nextStage']),
  }
}
